import common from './common';
import home from './home';
import routes from './routes';
import adminSettingBooth from './adminSettingBooth';
import adminSideBar from './adminSideBar';
import adminSettingSeminarRoom from './adminSettingSeminarRoom';
import productManagement from './productManagement';
import productRegister from './productRegister';
import organizerList from './organizerList';
import FAQ from './FAQ';
import visitHistoryManagement from './visitHistoryManagement';
import errorPage from './errorPage';
import adminSettingShoppingCart from './adminSettingShoppingCart';
import settingSellProductOrganizer from './settingSellProductOrganizer';
import adminSettingCustom from './adminSettingCustom';
import exhibition from './exhibition';
import livestream from './livestream';
import registerOrganizer from './registerOrganizer';
import registerViewer from './registerViewer';
import seminar from './seminar';
import shoppingCart from './shoppingCart';

const languageObject = {
    en: {
        ...home.en,
        ...routes.en,
        ...common.en,
        ...exhibition.en,
        ...adminSideBar.en,
        ...adminSettingBooth.en,
        ...adminSettingSeminarRoom.en,
        ...productManagement.en,
        ...productRegister.en,
        ...organizerList.en,
        ...FAQ.en,
        ...visitHistoryManagement.en,
        ...errorPage.en,
        ...adminSettingShoppingCart.en,
        ...settingSellProductOrganizer.en,
        ...adminSettingCustom.en,
        ...exhibition.en,
        ...livestream.en,
        ...registerOrganizer.en,
        ...registerViewer.en,
        ...seminar.en,
        ...shoppingCart.en,
    },
    ja: {
        ...common.ja,
        ...routes.ja,
        ...adminSideBar.ja,
        ...home.ja,
        ...adminSettingBooth.ja,
        ...adminSettingSeminarRoom.ja,
        ...productManagement.ja,
        ...productRegister.ja,
        ...organizerList.ja,
        ...FAQ.ja,
        ...visitHistoryManagement.ja,
        ...errorPage.ja,
        ...adminSettingShoppingCart.ja,
        ...settingSellProductOrganizer.ja,
        ...adminSettingCustom.ja,
        ...exhibition.ja,
        ...livestream.ja,
        ...registerOrganizer.ja,
        ...registerViewer.ja,
        ...seminar.ja,
        ...shoppingCart.ja,
    },
};

export default languageObject;
